//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterTotalSecond from '@/components/Counter/SlotCounterTotalSecond';
import dateUtils from '@/utils/dateUtil';
import vue from 'vue';
export default {
  name: 'ShopSale',
  components: {
    SlotCounterTotalSecond: SlotCounterTotalSecond
  },
  data: function data() {
    return {
      refIndex: 0,
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, dateUtils.todayTimestamp() * 1000],
      pickRange: {
        timeOptionRange: null
      },
      pickerOptionsStart: {
        onPick: function onPick(pTime) {
          if (pTime.minDate && !pTime.maxDate) {
            vue.timeOptionRange = pTime.minDate;
          }

          if (pTime.maxDate) {
            vue.timeOptionRange = null;
          }
        },
        disabledDate: function disabledDate(pTime) {
          var timeOptionRange = vue.timeOptionRange;
          var limitDays = 31 * 86400 * 1000;

          if (timeOptionRange) {
            return pTime.getTime() > timeOptionRange.getTime() + limitDays || pTime.getTime() < timeOptionRange.getTime() - limitDays;
          }
        }
      }
    };
  },
  created: function created() {},
  methods: {}
};